export default "__VITE_ASSET__DDQcjl19__"